<mat-toolbar class="mg-header">
  <button
    type="button"
    matIconButton
    class="mg-header__menu"
    aria-label="Abrir menu"
    (click)="abrirMenu.emit()"
  >
    <!-- SVG inline, e não `<mat-icon>`: ligadura vira nó de texto no botão. -->
    <svg viewBox="0 0 24 24" width="22" height="22" focusable="false" aria-hidden="true">
      <path fill="currentColor" d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" />
    </svg>
  </button>

  <a routerLink="/" class="mg-header__logo">
    <img src="./assets/marca/Mais Gestao - Horizontal_cor.webp" alt="Mais Gestão" />
  </a>

  <!--
    A busca saiu do canto direito e passou a morar aqui, logo depois do logo e
    bem mais larga (05/09/2026, arranjo aprovado pelo dono). O motivo é de
    forma: à direita, com o tamanho de um botão de ícone, ela lia como "mais um
    ícone"; à esquerda e larga, ela lê como o campo de busca que é. O
    comportamento não mudou — continua abrindo a MESMA paleta (`mat-dialog`),
    pelo mesmo `Ctrl K`.

    `data-tour="header.busca"` saiu em 28/09/2026: o tour do painel deixou de
    narrar este botão (`dashboard.tour.ts`, redesenho de 4 alvos focados no
    fluxo de implantação). O atalho `Ctrl K` continua funcionando.
  -->
  <button
    type="button"
    matButton="outlined"
    class="mg-header__busca"
    aria-label="Buscar no sistema"
    (click)="abrirBusca()"
  >
    <mat-icon svgIcon="search" aria-hidden="true"></mat-icon>
    <span class="mg-header__busca-rotulo">Buscar…</span>
    <span class="mg-header__busca-tecla">Ctrl K</span>
  </button>

  <!-- O padrão de espaçador do mat-toolbar: quem empurra as ações para a
  direita é o flex do próprio toolbar, não um margin-left: auto nosso. -->
  <span class="mg-header__espaco"></span>


  @if (ehTenant) {
    <mg-credits-balance />
  }

  <!--
    Badge de contabilidade — TRANSPARÊNCIA, não enfeite: o cliente precisa
    poder ver, a qualquer momento, que um terceiro enxerga os dados dele e QUEM
    é esse terceiro. Por isso o rótulo "Contabilidade" fica visível ao lado do
    nome: só o nome, solto entre a busca e o sino, não diz o que ele é.

    Só aparece com vínculo `active` — quem filtra é o `AccountingBadgeService`
    (`pending` é convite não aceito e `revoked` é acesso encerrado: nenhum dos
    dois dá leitura a ninguém, e mostrá-los mentiria para o cliente).

    A lista INTEIRA é renderizada, não `[0]`: com dois escritórios ativos, ver
    um e não o outro é a mesma mentira em outra forma.
  -->
  @if (vinculosContabeis.length > 0) {
    <div
      data-teste="badge-contabilidade"
      class="mg-header__badge-contabilidade"
      [attr.aria-label]="rotuloAcessivelDaContabilidade"
      [matTooltip]="rotuloAcessivelDaContabilidade"
    >
      <mat-icon svgIcon="calculate" class="mg-header__badge-contabilidade-icone" aria-hidden="true"></mat-icon>
      <span class="mg-header__badge-contabilidade-rotulo">Contabilidade</span>
      <span class="mg-header__badge-contabilidade-nomes">{{ nomesDosEscritorios }}</span>
    </div>
  }

  <!--
    O nome do usuário SAIU daqui em 01/09/2026: ele aparecia aqui e no rodapé
    do menu lateral ao mesmo tempo. O bloco de perfil (`mg-menu-usuario`) passou
    a morar no menu lateral, que é onde as duas referências o colocam.
  -->

  @if (podeVerNotificacoes) {
    <button
      type="button"
      matIconButton
      class="mg-header__notificacoes"
      [attr.aria-label]="naoLidas > 0 ? 'Notificações, ' + naoLidas + ' não lidas' : 'Notificações'"
      aria-haspopup="dialog"
      [attr.aria-expanded]="notificacoesAbertas"
      (click)="abrirNotificacoes()"
    >
      <span class="mg-header__contador" [matBadge]="naoLidas" matBadgeSize="small"><mat-icon svgIcon="notifications" aria-hidden="true"></mat-icon></span>
    </button>
  }

  @if (ehTenant && !onboarding.orbitaLiberada() && (onboarding.estado()?.elegivel || onboarding.erro())) {
    <button type="button" matIconButton aria-label="Primeiros passos" matTooltip="Primeiros passos" (click)="onboarding.abrir()">
      <mat-icon svgIcon="school" aria-hidden="true"></mat-icon>
    </button>
  }

  @if (ehTenant) {
    <button
      type="button"
      matIconButton
      class="mg-header__suporte"
      [attr.aria-label]="rotuloDoGatilhoDeSuporte()"
      matTooltip="Ajuda e suporte"
      aria-haspopup="dialog"
      [attr.aria-expanded]="hub.aberto()"
      (click)="hub.abrir()"
    >
      <span class="mg-header__contador" [matBadge]="hub.contagem()" [matBadgeHidden]="hub.contagem() === 0" matBadgeSize="small"><mat-icon svgIcon="help" aria-hidden="true"></mat-icon></span>
    </button>
  }
  <!--
    Achado da revisão (rodada 4): `<app-support-hub />` MORAVA aqui dentro do
    `<mat-toolbar>`. O `.mg-header` é `sticky` com `z-index: 95` e forma o
    próprio contexto de empilhamento — o painel/véu (z-index 50/40) ficavam
    PRESOS dentro dele, então o cabeçalho sticky de qualquer `kt-table`
    (z-index 100, do CDK) desenhava por cima do véu sem escurecer, escondendo
    o painel. A herança de `white-space: nowrap` do `.mat-toolbar-single-row`
    e a regra `.mat-toolbar h2` do Material (sem camada, vencendo
    `.mg-suporte-painel__titulo`) também vinham daqui. O painel foi para a
    raiz do shell (`layout.component.html`), fora do `mat-toolbar`; a nota da
    spec §6.1 sobre os níveis de empilhamento ficou desatualizada.
  -->


  <!--
    "Sua jornada" — a Órbita Financeira (07/09/2026). Só na casca do TENANT,
    e SEM gate de permissão: o overlay abre para todo mundo e
    é a API quem responde pelo dado. O ponto pulsante (`--novidade`) marca
    conquista nova desde a última abertura deste usuário. Sem `data-tour`:
    o portão `tutorial-alvos` reprova atributo sem passo de tour que o use —
    ele entra junto com o passo, quando o tour do painel o ganhar.
  -->
  @if (ehTenant && onboarding.orbitaLiberada() && orbitaIncluida) {
    <button
      type="button"
      matIconButton
      class="mg-header__jornada"
      [class.mg-header__jornada--novidade]="jornada.idsNovos().length > 0"
      aria-label="Sua jornada"
      matTooltip="Sua jornada"
      (click)="jornada.abrir()"
    >
      <mat-icon svgIcon="orbit" aria-hidden="true"></mat-icon>
    </button>
  }

  <!--
    Clique DIRETO, sem `mat-menu`: hoje só há um item. O menu volta no dia em
    que houver um segundo (a ajuda desta tela, da base de conhecimento).
    Desabilitado, e não ausente, quando a rota não tem tour: botão que some e
    volta conforme a tela ensina o usuário a não procurar.

    Só no ADMIN (spec suporte enterprise §6.1, 26/09/2026): no tenant este
    ícone SAIU daqui — o tour agora se pede de dentro do painel "Ajuda e
    suporte" ("Ver tour desta tela"). A abertura solicitada pelo usuário
    independe do onboarding. Apenas o disparo automático continua vinculado
    à tarefa aberta pelo roteiro. No admin o botão permanece visível e fica
    desabilitado quando a rota não tem tour.
  -->
  @if (!ehTenant) {
  <button
    type="button"
    matIconButton
    class="mg-header__ajuda"
    aria-label="Ver tour desta tela"
    matTooltip="Ver tour desta tela"
    [disabled]="!tutorial.temTourNaRota()"
    (click)="tutorial.iniciarTourDaRota()"
  >
    <mat-icon svgIcon="help" aria-hidden="true"></mat-icon>
  </button>
  }
</mat-toolbar>
